import React from 'react';

import { useTranslation } from '@crehana/i18n';

const PendingOnlinePayment = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-16 mb-42">
      <p className="font-body3 mb-16 text-red-main tw-font-semibold">
        {t('PAYMENT_WARNING')}
        <span className="font-body3 text-purple-main">
          {t('CREHANA_EMAIL')}
        </span>
      </p>
    </div>
  );
};

export default PendingOnlinePayment;
